<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new transporter truck</small>
      </legend>
      <div>
        <form @submit.prevent="newTruck()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="transporter_id" :value="Transporter.id" />
              <div class="form-group">
                <label>Truck no</label>
                <input
                  type="text"
                  class="form-control truck_no"
                  placeholder="truck number plate"
                  required
                />
              </div>
              <div class="form-group">
                <label>Truck license Date</label>
                <input
                  type="date"
                  class="form-control truck_license_Date"
                  placeholder="truck license date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Trailer License date</label>
                <input
                  type="date"
                  class="form-control trailer_license_Date"
                  placeholder="trailer_license_Date"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Trailer no</label>
                <input
                  type="text"
                  class="form-control trailer_no"
                  placeholder="trailer number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Truck Expiry date</label>
                <input
                  type="date"
                  class="form-control truck_expiry_date"
                  placeholder="truck expiry date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Trailer Expiry date</label>
                <input
                  type="date"
                  class="form-control trailer_expiry_date"
                  placeholder="trailer_expiry_date"
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingTruck btn-rounded">
            <i class="fa fa-truck"></i>Add Truck
          </button>
          <button type="button" class="btn btn-primary btn-flat creatingTruckLoader btn-rounded">
            <i class="fa fa-spinner fa-spin" style="font-size:24px;"></i>please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router";
export default {
  created() {
    if (this.$store.getters.Transporter.length === 0) {
      router.push("/managetransporters");
    }
  },
  computed: {
    ...mapGetters(["Transporter"])
  },
  methods: {
    ...mapActions(["newTruck"])
  }
};
</script>
<style scoped>
.creatingTruckLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucks/trucks.vue